const BASE_URL = '/connect-store';

export const ROUTES = {
  ROOT: BASE_URL,
  LOGIN: '/login',
  SHOPIFY_CONNECT: `${BASE_URL}/shopify`,
  WOO_CONNECT: `${BASE_URL}/woocommerce`,
  BIGCOMMERCE: `${BASE_URL}/bigcommerce`
};
